export default {
    edit: 'Redaguoti',
    location: 'Vieta + Taisyklės ir sąlygos',
    filter: 'Filtruoti',
};
